import { render, staticRenderFns } from "./TheTerms.vue?vue&type=template&id=2a46fd75"
import script from "./TheTerms.vue?vue&type=script&lang=js"
export * from "./TheTerms.vue?vue&type=script&lang=js"
import style0 from "./TheTerms.vue?vue&type=style&index=0&id=2a46fd75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports